.icon {
    width: 240px;
}
